'use strict';

angular.module('ClinicApp').config(function($stateProvider) {
  $stateProvider.state('claim-verify', {
    url: '/claim/:clinicId/verify/',
    templateUrl: '/views/claim-verify.html',
    controller: 'ClaimClinicVerifyCtrl',
    data: {
      hideNavigation: true,
      showSearchFooter: true,
    },
    resolve: {
      clinic: function($stateParams, ClinicService) {
        return ClinicService.getClinic($stateParams.clinicId);
      },
      pageTitle: function($pageTitle, clinic) {
        $pageTitle.set('Verify - ' + clinic.name + ' - Opencare');
      },
    },
  });
});

angular.module('ClinicApp').controller('ClaimClinicVerifyCtrl', function($scope, $timeout, CurrentUser, OCClinicUtil, clinic, OCMapUtil, OCModalUtil, OCPhotoUtil) {
  $scope.clinic = clinic;
  $scope.visitorsCount = randomVisitorsCount(clinic);
  $scope.primaryPhotoForModel = OCPhotoUtil.primaryPhotoForModel;

  // Enable popovers.
  angular.element('[data-toggle="popover"]').popover();

  $timeout(function() {
    var map = OCMapUtil.newMap(document.getElementById('map-canvas'), $scope.clinic.latitude, $scope.clinic.longitude);
    if (!map) {
      return;
    }
    OCMapUtil.addMarker(map, $scope.clinic.latitude, $scope.clinic.longitude);

    google.maps.event.addListenerOnce(map, 'idle', function() {
      var windowWidth = window.innerWidth || document.clientWidth;
      var mapBounds = map.getBounds();
      // Place marker in the center.
      var newLongitude = mapBounds.getSouthWest().lng()
        - (mapBounds.getSouthWest().lng()
          - mapBounds.getNorthEast().lng()) / 2.0;
      if (windowWidth >= 768) {
        // Place marker on 1/4 right from the center.
        newLongitude = (
          mapBounds.getSouthWest().lng()
          - (mapBounds.getSouthWest().lng()
            - mapBounds.getNorthEast().lng()) / 4.0
        );
      }
      map.panTo(new google.maps.LatLng(map.getCenter().lat(), newLongitude));
    });
  });

  function randomVisitorsCount(clinic) {
    // Using seeded random number generator from David Bau.
    // https://github.com/davidbau/seedrandom
    var currentMonth = new Date().getUTCMonth();
    var seed = String(clinic.id + currentMonth);
    var rng = null;
    try {
      rng = new Math.seedrandom(seed);
    } catch (_err) {
      // Fallback when "seedrandom" lib is not loaded.
      rng = Math.random;
    }
    return Math.floor(rng() * (30 - 10) + 10);
  }

  function openModalToSignup(verificationCode) {
    OCModalUtil.showCustomModal({
      windowClass: 'claim-signup-modal',
      templateUrl: '/views/modals/_claim-signup.html',
      controller: 'ModalClaimSignup',
      resolve: OCModalUtil.createResolve({
        clinicId: $scope.clinic.id,
        verificationCode,
      }),
    });
  }

  $scope.openModalToVerifyPhone = function() {
    OCModalUtil.showModal(
      'clinicPhoneVerify',
      {
        clinic: $scope.clinic,
        modalType: 'CLAIM',
      },
    ).then(function(verificationCode) {
      // Phone number has been verified.
      CurrentUser.waitForUserLoad(CurrentUser.isAuthenticated).then(function(authenticated) {
        if (authenticated) {
          OCClinicUtil.claimClinic($scope.clinic.id, verificationCode);
        } else {
          openModalToSignup(verificationCode);
        }
      });
    });
  };

});
